import { SMARTLINK_CONNECTION_LINK_COUNT_TRAIT } from '@atlassian/confluence-account-setup/entry-points/smartlink-connector-recommendations';

import { useTapTrait } from './useTapTrait.ts';
import type { BannerTraitHookOptions, TapTraitResult } from './useTapTrait.ts';

// Provider key as encoded in the confluence_3p_smartlink_connection_link_count trait value.
export const GOOGLE_DRIVE_PROVIDER_KEY = 'google-drive';

export function parseLinkCount(raw: string | undefined): Record<string, number> | undefined {
	if (raw === undefined || raw.trim() === '') {
		return undefined;
	}

	const counts = raw.split(',').reduce<Record<string, number>>((acc, segment) => {
		const colonIdx = segment.indexOf(':');
		if (colonIdx === -1) return acc;
		const provider = segment.slice(0, colonIdx).trim();
		const countRaw = segment.slice(colonIdx + 1).trim();
		if (!provider || countRaw === '') return acc;
		const count = Number(countRaw);
		if (!Number.isInteger(count) || count < 0) return acc;
		acc[provider] = count;
		return acc;
	}, {});

	return Object.keys(counts).length > 0 ? counts : undefined;
}

export type UseSmartlinkConnectionLinkCountResult = TapTraitResult<Record<string, number>>;

export function useSmartlinkConnectionLinkCount({
	skip,
}: BannerTraitHookOptions = {}): UseSmartlinkConnectionLinkCountResult {
	return useTapTrait(SMARTLINK_CONNECTION_LINK_COUNT_TRAIT, parseLinkCount, { skip });
}
